import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  addToBasket,
  getBasket,
  getCheckSum,
  getMessage,
  getShadows,
  hiddenShadow,
  setCheckSum,
} from "../../redux/Calc_reducer";
import Basket from "../Basket/Basket";
import CalcForm from "./CalcForm";
import Modal from "../Modal/Modal";
import { messageChatErase } from "../../redux/Chat_reducer";

const Calculator = (props) => {
  const shadowFalse = (id) => {
    props.hiddenShadow(id);
  };
  const [reloadBeforeBasket, setReloadBeforeBasket] = React.useState(false);

  React.useEffect(() => {
    setReloadBeforeBasket(false);
  }, [reloadBeforeBasket]);

  const onSubmit = (values) => {
    setReloadBeforeBasket(true);
    props.addToBasket(values);
  };
  const [active, setActive] = useState(false);
  const setActiveModal = () => {
    setActive(false);
    props.messageChatErase("");
  };
  useEffect(() => {
    if (props.message?.substr(0, 3) === "Ува") {
      setActive(true);
    }
  }, [props.message]);

  return (
    <div className="blockContent">
      <div className="block block_4" id="calculator">
        <CalcForm
          {...props}
          reloadBeforeBasket={reloadBeforeBasket}
          onSubmit={onSubmit}
          setCheckSum={props.setCheckSum}
          shadowFalse={shadowFalse}
        />
        {props.basket?.length > 0 && <Basket setModal={props.setModal}/>}
        <Modal active={active} setActive={setActiveModal}>
          {props.message}
        </Modal>
      </div>
    </div>
  );
};

const mstp = (state) => ({
  shadows: getShadows(state),
  basket: getBasket(state),
  checkSum: getCheckSum(state),
  message: getMessage(state),
});

const mdtp = (dispatch) => ({
  hiddenShadow: (p) => dispatch(hiddenShadow(p)),
  addToBasket: (p) => dispatch(addToBasket(p)),
  setCheckSum: (p) => dispatch(setCheckSum(p)),
  messageChatErase: (p) => dispatch(messageChatErase(p)),
});

export default connect(mstp, mdtp)(Calculator);
